module.exports = __webpack_public_path__ + "static/img/dominos-dostawca.66d7823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-dostawca.png
// module id = lE4O
// module chunks = 0